import { Box, Modal as MuiModal, Typography } from '@mui/material';

const boxStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
};

const CloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path
                fill="hsl(220, 9%, 80%)"
                d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
            />
        </svg>
    );
};

export const Modal = ({
    children,
    open,
    onClose,
    title,
    width = '80vw',
    height = '80vh',
    backgroundColour = 'white',
    overflowX = 'visible',
    overflowY = 'visible',
}) => {
    return (
        <MuiModal open={open} onClose={onClose}>
            <Box
                padding="24px"
                borderRadius="12px"
                bgcolor={backgroundColour}
                width={width}
                height={height}
                sx={{ ...boxStyle, overflowX, overflowY }}
            >
                <Box display="flex" flexDirection="row" justifyContent="space-between">
                    <Typography variant="h6" component="h2">
                        {title}
                    </Typography>
                    <Box onClick={onClose} sx={{ cursor: 'pointer' }}>
                        <CloseIcon />
                    </Box>
                </Box>

                <Box paddingY="16px">{children}</Box>
            </Box>
        </MuiModal>
    );
};

// can you use values in theme for prop values?
